import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Space, Upload, Col, Row, Select, TimePicker, DatePicker, Radio, Divider } from 'antd';
import AddDrawer from '../../component/AddDrawer';
import '../../style/page.css'
import { useDispatch, useSelector } from 'react-redux';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { editPendingStatusEnquiry, getEnquiry } from '../../feature/enquiry/enquirySlice';
import { getAllSubscription } from '../../feature/subscription/subscriptionSlice';
import { ImageUp } from 'lucide-react';
import dayjs from 'dayjs';
import { currencyData } from '../../constant/Constatnt';



function EditPendingEnquiry({ editData }) {
    const [uploadStates, setUploadStates] = useState({});

    const { _id,
        numberOfTeachers,
        numberOfStudents,
        numberOfAdmins,
        schoolName,
        locationName,
        notes, ownerEmail, startDate, subScriptionId,currencyCode } = editData || {}

    const { actionLoader } = useSelector((state) => state.enquiries);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()
    const { allSubscriptionList } = useSelector((state) => state.subscriptions);

    useEffect(() => {
        if (open) {
            dispatch(getAllSubscription());
        }
    }, [open])


    useEffect(() => {
        form.setFieldsValue({
            numberOfTeachers,
            numberOfStudents,
            numberOfAdmins,
            schoolName,
            locationName,
            notes,
            email: ownerEmail,
            startDate: startDate ? dayjs(startDate, "DD-MM-YYYY") : "",
            subScriptionId,
            currencyCode,
        })
    }, [open])

    const onFinish = async (values) => {
        const formData = new FormData();

        const fileKeys = ["licenses"];

        for (const [key, value] of Object.entries(values)) {


            if (fileKeys.includes(key) && Array.isArray(value)) {
                value.forEach((license, index) => {
                    // document name
                    if (license.documentName) {
                        formData.append(
                            `licenses[${index}].documentName`,
                            license.documentName
                        );
                    }

                    // document images
                    license.documentImage?.forEach((img, imgIndex) => {
                        const file = img?.originFileObj || img?.file;
                        if (file instanceof File) {
                            formData.append(
                                `licenses[${index}].documentImage[${imgIndex}]`,
                                file
                            );
                        }
                    });
                });
                continue;
            }
            if (value && dayjs.isDayjs(value)) {
                formData.append(key, value.format("DD-MM-YYYY"));
                continue;
            }
            // Handle normal objects
            if (typeof value === "object" && value !== null) {
                formData.append(key, JSON.stringify(value));
                continue;
            }

            // Handle primitive values
            formData.append(key, value ?? "");
        }

        // append id separately
        formData.append("daycareEnqueryId", _id);

        const resultAction = await dispatch(
            editPendingStatusEnquiry(formData)
        );

        if (editPendingStatusEnquiry.fulfilled.match(resultAction)) {
            await dispatch(getEnquiry({}));
            form.resetFields();
            setOpen(false);
        } else {
            console.error("edit modules");
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Validation Failed:', errorInfo);
    };

    const handleCancel = () => {
        form.resetFields();
    };


    const AddForm = (
        <Form
            layout="vertical"
            form={form}
            name="add-service-form"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}

        >
            <Row gutter={{ lg: 24 }}>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        name="schoolName"
                        label="School Name"
                        rules={[{ required: true, message: 'Please enter school  name' }]}
                    >
                        <Input placeholder="Enter School  Name" size='large' />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        name="locationName"
                        label="Location  Name"
                        rules={[{ required: true, message: 'Please enter location   name' }]}
                    >
                        <Input placeholder="Enter Location Name" size='large' />
                    </Form.Item>
                </Col>

            </Row>
            <Row gutter={{ lg: 24 }}>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        name="numberOfAdmins"
                        label="No. of Admin"
                        rules={[{ required: true, message: 'Please enter number of admin   ' }]}
                    >
                        <Input placeholder="Enter Number of Admin" size='large' />
                    </Form.Item>
                </Col>

                <Col className="gutter-row" span={12}>
                    <Form.Item
                        name="numberOfTeachers"
                        label="No. of Teachers"
                        rules={[{ required: true, message: 'Please enter number of teachers   ' }]}
                    >
                        <Input placeholder="Enter Number of Teachers" size='large' />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={{ lg: 24 }}>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        name="numberOfStudents"
                        label="No. of Students"
                        rules={[{ required: true, message: 'Please enter Number of Students   ' }]}
                    >
                        <Input placeholder="Enter Number of Students" size='large' />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        name="subScriptionId"
                        label="Subscription"
                        rules={[{ required: true, message: 'Please enter subscriptionList   ' }]}
                    >
                        <Select placeholder="Select subscription">
                            {allSubscriptionList?.map((item) => (
                                <Select.Option key={item._id} values={item._id}>
                                    {item.planName}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={{ lg: 24 }}>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        label="Start Date"
                        name="startDate"
                        rules={[{ required: true, message: 'Please enter start date    ' }]}
                    >
                        <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        label="Expiry Date"
                        name="expiryDate"
                        rules={[{ required: true, message: 'Please enter end date' }]}
                    >
                        <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={{ lg: 24 }}>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            {
                                required: true,
                                message: "Please enter email "
                            },
                        ]}
                    >
                        <Input
                            size="large"
                            placeholder="Enter  Email"
                        />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: "Please enter   password !",
                            },
                        ]}
                    >
                        <Input.Password
                            type="password"
                            placeholder="Enter Password"
                            size="large"

                        />
                    </Form.Item>
                </Col>
            </Row>
            <Col xs={24} s={24} md={24} lg={12} >

                <Form.Item
                    name="currencyCode"
                    label="Currency Code"
                    rules={[{ required: true, message: 'Please select currency code' }]}
                >
                    <Select placeholder="Select Currency Code">
                        {currencyData?.map((item) => (
                            <Select.Option key={item} value={item}>{item}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>
            <Col xs={24} s={24} md={24} lg={24} >
                <Form.List
                    name="licenses"
                    rules={[{ required: true, message: 'Please upload a File' }]}

                >
                    {(fields, { add, remove }, { errors }) => (
                        <>
                            {fields.map((field, index) => {
                                const fileList = uploadStates[field.key] || [];

                                const handleUploadChange = (info) => {
                                    setUploadStates((prev) => ({
                                        ...prev,
                                        [field.key]: info.fileList,
                                    }));
                                };

                                return (
                                    <div key={field.key} className="dynamic-form-item">
                                        <Row gutter={16}>
                                            {/* Text Input */}
                                            <Col span={24}>
                                                <Form.Item
                                                    label={`Document Name ${index + 1}`}
                                                    name={[field.name, 'documentName']}
                                                    rules={[{ required: true, message: 'Please enter document name' }]}
                                                >
                                                    <Input placeholder="Enter Document Name" />
                                                </Form.Item>
                                            </Col>

                                            {/* Image Upload */}
                                            <Col span={24}>
                                                <div className='dynamic_forms_input'>
                                                    <Form.Item

                                                        name={[field.name, 'documentImage']}
                                                        valuePropName="fileList"
                                                        getValueFromEvent={(e) => Array.isArray(e) ? e : e?.fileList}
                                                        rules={[{ required: true, message: 'Please upload a File' }]}
                                                    >
                                                        <Upload
                                                            listType="picture"
                                                            beforeUpload={() => false}
                                                            accept=".jpg,.jpeg,.png"
                                                            fileList={fileList}
                                                            onChange={handleUploadChange}
                                                            maxCount={1}
                                                        >
                                                            {fileList.length < 1 && (
                                                                <Button icon={<ImageUp />}>Choose File</Button>
                                                            )}
                                                        </Upload>
                                                    </Form.Item>
                                                    {fields.length > 1 && (
                                                        <MinusCircleOutlined
                                                            style={{ fontSize: '18px', color: 'red' }}
                                                            onClick={() => remove(field.name)}
                                                        />
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                );
                            })}
                            {/* Add Point Button */}
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    block
                                    icon={<PlusOutlined />}
                                >
                                    Add  Document
                                </Button>
                                <Form.ErrorList errors={errors} />
                            </Form.Item>
                        </>
                    )}
                </Form.List>
            </Col>
            <Col className="gutter-row" span={24}>
                <Form.Item
                    name="notes"
                    label="Notes"
                // rules={[{ required: true, message: 'Please enter Notes' }]}
                >
                    <Input.TextArea placeholder="Enter Note..." />
                </Form.Item>
            </Col>
            {/* <Divider orientation='left'>Bank Details</Divider>
            <Row gutter={{ lg: 24 }}>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        name="accountHolderName"
                        label="Account Holder Name"
                        rules={[{ required: true, message: 'Please enter account holder name   ' },
                        
                        ]}
                    >
                        <Input placeholder="Enter Account Holder Name" size='large' />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        name="bankName"
                        label="Bank Name"
                        rules={[{ required: true, message: 'Please enter bank name  ' },
                        
                        ]}
                    >
                        <Input placeholder="Enter Bank Name" size='large' />
                    </Form.Item>
                </Col>

            </Row>
            <Row gutter={{ lg: 24 }}>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        name="accountNumber"
                        label="Account Number"
                        rules={[{ required: true, message: 'Please enter account number   ' },
                        { pattern: /^[0-9]+$/, message: "Only numbers are allowed" }

                        ]}
                    >
                        <Input placeholder="Enter Account Number" size='large' />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        name="ifscCode"
                        label="IFSC"
                        rules={[{ required: true, message: 'Please enter ifscCode   ' }]}
                    >
                        <Input placeholder="Enter IFSC Code" size='large' />
                    </Form.Item>
                </Col>

            </Row>
            <Col className="gutter-row" span={12}>
                <Form.Item
                    name="branchName"
                    label="Branch Name"
                    rules={[{ required: true, message: 'Please enter branch name   ' }]}
                >
                    <Input placeholder="Enter Branch Name" size='large' />
                </Form.Item>
            </Col> */}


            <Form.Item  >

                <div className='submit_btn'>
                    <Space>
                        <Button danger htmlType="button" onClick={handleCancel}>
                            Reset
                        </Button>
                        <Button type="primary" loading={actionLoader} htmlType="submit">
                            Submit
                        </Button>
                    </Space>
                </div>
            </Form.Item>
        </Form >


    );

    const editProps = {
        open,
        setOpen,
        title: 'Update  Enquiry',
        action: 'Edit',
        content: AddForm,
        btnType: "link",
        sizes: "600"
    };

    return (
        <section>
            <AddDrawer {...editProps} />
        </section>
    );
}


export default EditPendingEnquiry